var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForensic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.88 47.26C37.6878 47.26 47.26 37.6878 47.26 25.88C47.26 14.0722 37.6878 4.5 25.88 4.5C14.0722 4.5 4.5 14.0722 4.5 25.88C4.5 37.6878 14.0722 47.26 25.88 47.26Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1299 40.85L55.3899 55.11",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.55 14.81V17.96C18.55 21.08 20.3201 23.94 23.1101 25.34L28.66 28.11C31.45 29.51 33.22 32.36 33.22 35.49V38.64",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.82 32.02C19.39 33.07 18.55 34.74 18.55 36.51V38.64",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.21 14.81V16.91C33.21 18.66 32.38 20.31 30.96 21.34",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.89,
    height: 55.61,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForensic);
export default __webpack_public_path__ + "static/media/forensic.521e8ed498942d82c3e81580cfb25569.svg";
export { ForwardRef as ReactComponent };